import React from 'react';
import ReloadIcon from 'mdi-react/ReloadIcon';

import { IActionsButtons } from '@crm-framework/actions-buttons';

type RefreshActionButtonCreatorParams = {
  isLoading: boolean;
  handleRefresh: (...params: any) => any;
  baseAppearance?: string;
};

export const getRefreshActionButton: (
  params: RefreshActionButtonCreatorParams
) => IActionsButtons = ({
  isLoading,
  handleRefresh,
  baseAppearance = 'info',
}) => ({
  title: 'Refresh',
  type: 'button',
  baseAppearance,
  appearance: 'info',
  prefix: <ReloadIcon size="18" />,
  isDisabled: isLoading,
  onClick: handleRefresh,
});
